module.exports = __webpack_public_path__ + "img/Priest-dwarf-m-70.0c7d5bc3.gif";